const middleware = {}

middleware['admin_authenticated'] = require('../middleware/admin_authenticated.ts')
middleware['admin_authenticated'] = middleware['admin_authenticated'].default || middleware['admin_authenticated']

middleware['payment_enabled'] = require('../middleware/payment_enabled.ts')
middleware['payment_enabled'] = middleware['payment_enabled'].default || middleware['payment_enabled']

export default middleware
